function purchaseDataKey() {
  const lsTimestamp = $('.purchase-timestamp').data('local-storage-timestamp')
  return `purchase-data-${lsTimestamp}`
}

function purchaseUniqueKey(codeId, branchId, unitCostPrice, quantity) {
  return `${branchId}${codeId}${unitCostPrice.replace('.', '-')}${quantity.replace('.', '-')}`
}

function productCodeId() {
  return $('#selected-product-code option:selected').val()
}

function productCodeName() {
  return $('#selected-product-code option:selected').data('code-name')
}

function productId() {
  return $('#add-purchase-form').data('product-id')
}

function addProductStock() {
  $("#add-serial-batch").click(function () {

    const branchId = $('#selected-branch-id option:selected').val()
    const branchName = $('#selected-branch-id option:selected').data('branch-name')
    const codeId = productCodeId()
    const codeName = productCodeName()
    const unitCostPrice = removeCommas($('#unit-cost-price').val()) || '0';
    const quantity = getProductQuantity();
    const uniquekey = purchaseUniqueKey(codeId, branchId, unitCostPrice, quantity)

    if ($("#" + uniquekey).length > 0) {
      toastNotification('error', `Product ${codeName} already added`);
    } else if (isNaN(unitCostPrice) || allWhiteSpaces(unitCostPrice) ||
      isNaN(quantity) || allWhiteSpaces(quantity)) {
      toastNotification('error', 'Quantity or Unit Cost is not valid');
    } else {

      const purchaseItem = {
        key: uniquekey,
        code_name: codeName,
        code_id: codeId,
        unit_cost_price: unitCostPrice,
        quantity: quantity,
        total_amount: quantity * unitCostPrice,
        branch_id: branchId,
        branch_name: branchName
      }

      storeItemInLocalStorage(purchaseItem, purchaseDataKey())
      setPurchaseDataRows()
    }
  });
}

function setInitialPurchaseData(view = 'edit', purchaseIdAttr) {
  localStorage.removeItem(purchaseDataKey())
  let purchaseId = $('#add-purchase-form input[name="purchase[purchase_id]"').val()

  if (view === 'index') {
    purchaseId = purchaseIdAttr
  }
  const action = $('#add-purchase-form input[name="purchase[purchase_action]"').val()

  if (view === 'edit' && (action === 'create' || purchaseId === null || purchaseId === undefined)) {
    return
  }

  $.ajax({
    type: "post",
    url: `/purchase_details/${purchaseId}`,
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    success: function (data) {
      console.log(data)
      localStorage.setItem(purchaseDataKey(), JSON.stringify(data))
      setPurchaseDataRows()
    },
    error: function (data) {
      $('#add-purchase-form input[name="commit"]').prop("disabled", false)
      console.log('An error occurred.');
      console.log(data);
    },
  });
}

function setPurchaseDataRows() {
  const purchaseData = JSON.parse(localStorage.getItem(purchaseDataKey()))
  const isHq = $('.purchase-page').data('is-headquarter')

  if (purchaseData === null || purchaseData === undefined) {
    console.log('ERROR')
    return
  }

  // remove current content
  $(".purchase-codes").empty()

  // set data rows
  $.each(purchaseData, function (key, purchaseDetails) {
    const branchName = purchaseDetails.branch_name
    const branchId = purchaseDetails.branch_id
    const codeName = purchaseDetails.code_name
    const quantity = purchaseDetails.quantity
    const unitCostPrice = purchaseDetails.unit_cost_price
    const totalAmount = purchaseDetails.total_amount
    const codeId = purchaseDetails.code_id
    const uniquekey = purchaseUniqueKey(codeId, branchId, unitCostPrice, quantity)

    $(".purchase-codes").append(
      `<tr id='${uniquekey}'>
          <td class="selected-branch" data-branch-id="${branchId}">${branchName}</td>
          <td class="code-name" >${codeName}</td>
          <td class="quantity text-right">${numberWithCommas(quantity)}</td>
          <td class="unit-cost-price text-right">${numberWithCommas(unitCostPrice)}</td>
          <td class="total-amount text-right">${numberWithCommas(totalAmount)}</td>
          <td>
            <a href='javascript:;' class='remove-purchase-items' data-uniquekey='${uniquekey}'
            >
              <i class='fa fa-minus-circle' style='font-size: 14px; margin-left: 15px; color: red'></i>
            </a>
          </td>
        </tr>`
    )


  })

  const totalAmount = numberWithCommas(calculatePurchaseTotal())
  const totalQuantity = numberWithCommas(calculatePurchaseQuantity())



  // set total row
  $(".purchase-codes").append(
    `<tr id='purchase-total'>
      <td></td>
      <td><strong>TOTAL</strong></td>
      <td class='total-quantity text-right'>${totalQuantity}</td>
      <td></td>
      <td class='total-sale text-right'>
        <strong>${totalAmount}</strong>
      </td>
      <td></td>
    </tr>`)


  $('input[name="purchase[total_amount]"]').val(totalAmount)
  $('input[name="purchase[quantity]"]').val(totalQuantity)


  // setTotalAmount();
  $('#unit-cost-price').closest('.form-group').removeClass('has-success');
  $('#first-serial-number').val('')
  $('#last-serial-number').val('')
}

function calculatePurchaseTotal() {
  const data = JSON.parse(localStorage.getItem(purchaseDataKey()))

  if (data === null || data === undefined) {
    console.log('ERROR')
    return 0
  }

  let totalAmount = Object.values(data).reduce(function (accumulator, curValue) {
    return accumulator + (parseFloat(curValue.unit_cost_price) * parseInt(curValue.quantity))
  }, 0)

  return totalAmount
}

function calculatePurchaseQuantity() {
  const data = JSON.parse(localStorage.getItem(purchaseDataKey()))

  if (data === null || data === undefined) {
    console.log('ERROR')
    return 0
  }

  let totalQuantity = Object.values(data).reduce(function (accumulator, curValue) {
    return accumulator + parseInt(curValue.quantity)
  }, 0)

  return totalQuantity
}

function removePurchaseItems() {
  $("table").on('click', '.remove-purchase-items', function () {
    const uniquekey = $(this).data('uniquekey');

    toastNotification('info', 'Removed Product');
    removeItemFromLocalStorage(uniquekey, purchaseDataKey())
    $(this).closest("tr").remove();
    setPurchaseDataRows()
    $('#unit-cost-price').closest('.form-group').removeClass('has-success');

  });
}

function submitPurchase() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];

    const dateOfPurchase = $('#add-purchase-form input[name="purchase[date_of_purchase]"]').val()
    const purchaseData = JSON.parse(localStorage.getItem(purchaseDataKey()))
    const description = $('#add-purchase-form textarea[name="purchase[description]"]').val()
    const batchNumber = $('#add-purchase-form input[name="purchase[batch_number]"]').val()
    const referenceNumber = $('#add-purchase-form input[name="purchase[reference_number]"]').val()

    if (JSON.stringify(purchaseData) === '{}' || JSON.stringify(purchaseData) === 'null') {
      errorString.push('Stock Not added');
    }

    if (isEmpty(dateOfPurchase)) {
      errorString.push(' Purchase date cannot be blank');
    }

    if (isEmpty(description)) {
      errorString.push('Description cannot be blank');
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      // $('#add-purchase-form').submit();
      const postUrl = $('#add-purchase-form').attr('action')
      const redirectUrl = '/purchases'
      const cashSourceId = $(`select[name="purchase[cash_source_id]"] option:selected`).val()
      const totalAmount = $('#add-purchase-form input[name="purchase[total_amount]"]').val()
      const quantity = $('#add-purchase-form input[name="purchase[quantity]"]').val()
      const purchaseAccountId = $('select[name="purchase[purchase_account_id]"] option:selected').val()
      const unitCostPrice = $('#add-purchase-form input[name="purchase[unit_cost_price]"]').val()
      const paymentOptions = getPaymentOptionsStorage()

      let action = "post"

      if ($('#add-purchase-form input[name="purchase[purchase_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          payment_options: paymentOptions,
          purchase: {
            purchase_data: purchaseData,
            date_of_purchase: dateOfPurchase,
            batch_number: batchNumber,
            reference_number: referenceNumber,
            description: description,
            cash_source_id: cashSourceId,
            total_amount: removeCommas(totalAmount),
            quantity: removeCommas(quantity),
            unit_cost_price: removeCommas(unitCostPrice),
            purchase_account_id: purchaseAccountId,
          }
        },
        dataType: "json",
        success: function (data) {
          removePaymentOptionData()
          localStorage.removeItem(purchaseDataKey())
          window.location.replace(redirectUrl)
          console.log(data)
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });
}

function setLastPurchasePrice() {
  let selectedCodeID = '#selected-product-code';
  const codeId = $(`${selectedCodeID} option:selected`).val();

  let unitcostPriceInputID = '#unit-cost-price';
  const costPriceInput = $(unitcostPriceInputID);

  $.ajax({
    type: "post",
    url: '/last_purchase_price',
    dataType: "json",
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    data: { code_id: codeId },
    success: function (data) {
      costPriceInput.val(data.last_price)
    },
    error: function (data) {
      console.log('An error occurred.');
      console.log(data);
    },
  });

}


$(document).ready(function () {
  if ($('#add-purchase-form').length > 0 && $('.unit-cost-price-div').length > 0) {
    checkAmount('.unit-cost-price', '.unit-cost-price-div');

    setInitialPurchaseData()
    addProductStock()
    removePurchaseItems()
    submitPurchase()
    setLastPurchasePrice()

    $('#selected-product-code').change(function () {
      setLastPurchasePrice()
    });

    clearFailedSubmit('#add-purchase-form')

  }

  $('.view-serial-numbers').click(function () {
    const purchaseId = $(this).data('purchase-id')
    setInitialPurchaseData('index', purchaseId)
    localStorage.removeItem(purchaseDataKey())
  })

  if ($('#add-product-form').length > 0 && $('.stock-div').length > 0) {
    checkAmount('.amount', '.amount-div');
    checkAmount('.stock-qty-value', '.stock-qty-div');
  }
});
